import ContactForm from "./subComponents/contactForm";
import communityPhoto from "../assets/images/coreValue2.png";

function Contact() {
	return (
		<section id="contact" className="contactSplit">
			<div className="contactSplitFrame">
				<div className="contactSplitVisual">
					<img
						src={communityPhoto}
						alt="GCAS members performing traditional music together at a cultural celebration"
						className="contactSplitPhoto"
					/>
					<div className="contactSplitScrim" aria-hidden="true"></div>
					<div className="contactSplitVisualContent">
						<h2 className="contactSplitHeadline">Let's stay connected.</h2>
						<div className="contactSplitInfo">
							<a
								href="mailto:info.gcasregina@gmail.com"
								className="contactSplitInfoLink"
							>
								info.gcasregina@gmail.com
							</a>
							<a href="tel:+13065022466" className="contactSplitInfoLink">
								+1 (306) 502 2466
							</a>
						</div>
					</div>
				</div>

				<div className="contactSplitFormPane">
					<ContactForm />
				</div>
			</div>
		</section>
	);
}

export default Contact;
